<div class="safety-dashboard" dir="rtl">
  <!-- Header -->
  <div class="head">
    <div class="head-right">
      <button class="back-btn" routerLink="/" title="بازگشت">
        <i class="fa fa-arrow-right"></i>
      </button>
      <div>
        <h1><i class="fa fa-car"></i> داشبورد جامع ایمنی رانندگی</h1>
        <div class="sub">
          تحلیل رفتار رانندگی مبتنی بر GPS
          <span *ngIf="(totalVehicles$ | async) as total"> • تحلیل {{ total }} خودرو</span>
        </div>
      </div>
    </div>
    <div class="head-left">
      <button class="btn-refresh" (click)="refresh()" title="بروزرسانی">
        <i class="fa fa-refresh" [class.fa-spin]="(loading$ | async)"></i> بروزرسانی
      </button>
    </div>
  </div>

  <!-- Tabs -->
  <div class="tabs">
    <button *ngFor="let t of tabs; trackBy: trackByTab"
      class="tab-btn"
      [class.active]="activeTab === t.id"
      (click)="setActiveTab(t.id)">
      <i class="fa {{ t.icon }}"></i> {{ t.label }}
    </button>
  </div>

  <div class="tab-panel" [class.active]="activeTab === 'overview'" *ngIf="activeTab === 'overview'">
    <app-safety-overview></app-safety-overview>
  </div>

  <div class="tab-panel" [class.active]="activeTab === 'speed'" *ngIf="activeTab === 'speed'">
    <app-safety-speed></app-safety-speed>
  </div>

  <div class="tab-panel" [class.active]="activeTab === 'risk'" *ngIf="activeTab === 'risk'">
    <app-safety-risk></app-safety-risk>
  </div>

  <div class="tab-panel" [class.active]="activeTab === 'quality'" *ngIf="activeTab === 'quality'">
    <app-safety-quality></app-safety-quality>
  </div>

  <div class="tab-panel" [class.active]="activeTab === 'table'" *ngIf="activeTab === 'table'">
    <app-safety-table></app-safety-table>
  </div>

</div>
